'use strict';
import React from 'react';
import AuthGoogleAccessForm from '../AuthGoogleAccessForm';
import CleverSignUp from './clever_sign_up';
import { ClasslinkButton } from '../../../../Shared/components/shared';

const AuthSignUp = () => {
  return (
    <div className='text-center auth-section'>
      <AuthGoogleAccessForm formClass="google-sign-up" offlineAccess={true} text="Sign up with Google" />
      <CleverSignUp />
      <ClasslinkButton isSignUp />
    </div>
  );
}

export default AuthSignUp;
